module.exports = __webpack_public_path__ + "files/bc9aebcfe7a1f38590f387d0da0c569b.png";